import FilterIcon from "@/assets/icons/FilterIcon.svg";
import SortIcon from "@/assets/icons/SortIcon.svg";
import InputField from "@/components/form/InputField";
import Filtering from "./Filtering";
import Sorting from "./Sorting";
import { TFilterOptions } from "../Projects";


type OrderStatsProps = {
  data:{
    page: number;
  limit: number;
  totalPages: number;
  totalProjects: number;
  totalInProgress: number;
  totalCompleted: number;
  }
  filter: TFilterOptions;
  setFilter: React.Dispatch<React.SetStateAction<TFilterOptions>>;
};

const ProjectStats = ({ filter, setFilter, data }: OrderStatsProps) => {
  const getButtonClassName = (value: string) => {
    const baseClasses =
      "flex items-center rounded-[32px] border border-[#E4E7EC] px-4 py-2.5";
    return filter === value ? `${baseClasses} bg-[#F2F4F7]` : baseClasses;
  };

  const FilterOptions = [
    {
      title: "All",
      value: "all",
      count: data?.totalInProgress+data?.totalCompleted,
    },
    {
      title: "In-Progress",
      value: "in-progress",
      count: data?.totalInProgress,
    },
    {
      title: "Completed",
      value: "completed",
      count: data?.totalCompleted,
    },
  ];

  return (
    <div>
      {/* Desktop */}
      <div className="hidden overflow-x-auto lg:overflow-visible w-full md:flex justify-between items-center">
        <div className="flex gap-x-3 items-center">
          {FilterOptions.map((item) => (
            <button
              onClick={() => setFilter(item.value as TFilterOptions)}
              key={item.value}
              className={getButtonClassName(item.value)}
            >
              <h5 className="text-sm leading-5 whitespace-nowrap font-medium">
                <span className="text-[#667085] ">{item.title}</span>{" "}
                {/* <span className="text-black">{item.count}</span> */}
              </h5>
            </button>
          ))}
        </div>
        {/* <div className="">
          <div className="flex pl-4 items-center gap-3">
            <Filtering />
            <Sorting />
          </div>
        </div> */}
      </div>
      {/* Mobile */}
      <MobileOrderStats
        filter={filter}
        filterOptions={FilterOptions}
        setFilter={setFilter}
      />
    </div>
  );
};

type MobileOrderStatsProps = {
  filter: TFilterOptions;
  filterOptions: {
    title: string;
    value: string;
    count: number | undefined;
  }[];
  setFilter: React.Dispatch<React.SetStateAction<TFilterOptions>>;
};

const MobileOrderStats = ({
  filter,
  filterOptions,
  setFilter,
}: MobileOrderStatsProps) => {
  const getButtonClassName = (value: string) => {
    const baseClasses =
      "w-full border-[1.5px] border-[#E4E7EC] p-2.5 rounded-xl space-y-3";
    return filter === value ? `${baseClasses} bg-[#F6F6F6] ` : baseClasses;
  };

  return (
    <div className="block md:hidden">
      <div className="grid grid-cols-2 gap-x-3 gap-y-2">
        {filterOptions.map((item) => (
          <div
            onClick={() => setFilter(item.value as TFilterOptions)}
            key={item.value}
            className={getButtonClassName(item.value)}
          >
            <h5 className="text-[#737B95] text-sm leading-4 tracking-[-3%] font-medium">
              {item.title}
            </h5>
            <p className="text-lg text-black font-semibold tracking-[-1.5%] leading-7">
              {item.count ? `${item.count}` : "0"}
            </p>
          </div>
        ))}
      </div>
      {/* <SearchFilterBar /> */}
    </div>
  );
};

// Search bar
const SearchFilterBar = () => {
  return (
    <div className="flex items-center gap-3 mt-7">
      <InputField
        name="Search"
        variant="search"
        placeholder="Search Clients.."
      />
      <div className="border-[1.5px] border-[#D0D5DD] rounded-lg py-2.5 px-4 flex items-center gap-2.5">
        <FilterIcon />
        <p className="text-[#344054] text-sm leading-5 font-medium">Filter</p>
      </div>
      <div className="border-[1.5px] border-[#D0D5DD] rounded-lg py-2.5 px-4  items-center gap-2.5 hidden">
        <SortIcon />
        <p className="text-[#344054] text-sm leading-5 font-medium">Sort</p>
      </div>
    </div>
  );
};

export default ProjectStats;
